module.exports = __webpack_public_path__ + "img/16.5c186680.jpg";